import _ from 'lodash';

import * as types from 'PointOfSale/modules/servingOptions/state/types';
import { SUB_MENU } from 'PointOfSale/mockData';

export const initialState = {
  activeSession: '',
  sessions: {},
  cepTypes: [],
  currentSession: {},
  servingSubMenuItems: _.cloneDeep(SUB_MENU),
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_CURRENT_SESSION:
      return {
        ...state,
        currentSession: payload,
      };
    case types.ON_SESSION_CREATED:
      return {
        ...state,
        activeSession: payload.activeSession,
        sessions: payload.sessions,
      };
    case types.CLEAR_CURRENT_SESSION:
      return {
        ...state,
        currentSession: {},
        servingSubMenuItems: _.cloneDeep(SUB_MENU),
      };
    case types.GET_SERVING_SUBMENU_ITEMS:
      return {
        ...state,
        servingSubMenuItems: payload,
      };
    case types.ON_SESSION_ADD:
      return {
        ...state,
        activeSession: payload.activeSession,
        sessions: payload.sessions,
      };
    case types.SET_ACTIVE_SESSION:
      return {
        ...state,
        activeSession: payload,
      };
    case types.CHANGE_QUICK_SERVE_ITEM:
      const sessionsClone = _.cloneDeep(state.sessions);
      sessionsClone[state.activeSession].quickServeItem = payload;
      return {
        ...state,
        sessions: {
          ...sessionsClone,
        },
      };
    case types.SET_ACTIVE_SESSION_INTERVAL:
      const sessionsCloneObj = _.cloneDeep(state.sessions);
      sessionsCloneObj[state.activeSession].timeInterval = payload;
      return {
        ...state,
        sessions: sessionsCloneObj,
      };
    case types.SET_AUTOSERVE_ON_OFF:
      const sessionsObj = _.cloneDeep(state.sessions);
      sessionsObj[state.activeSession].autoServe = payload;
      return {
        ...state,
        sessions: {
          ...sessionsObj,
        },
      };
    case types.GET_CEP_TYPES:
      return {
        ...state,
        cepTypes: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/state/reducer.js